import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { RequestLog } from '@features/shipments/models/request-log.model';
import { SectionState } from '@shared-features/enums/layout.enum';
import { RequestCreatedByType, RequestHistoryStatus } from '@shared-features/enums/shipments.enum';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-shipment-request-history',
  templateUrl: './shipment-request-history.component.html',
  styleUrls: ['./shipment-request-history.component.scss'],
})
export class ShipmentRequestHistoryComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('requestModal') requestModal: ModalComponent;
  @Input() logs: RequestLog[];
  @Input() handleEmptyRequestState: boolean;

  translatedLogList: any[];

  selectedItem: RequestLog & { label: string } = null;
  selectedAction: string = null;
  selectedItemState: SectionState = SectionState.Ready;
  selectedItemPayload: string = null;
  phrases$: Observable<any>;
  creatorType = RequestCreatedByType;
  destroy$ = new Subject();
  downloadString: SafeUrl;

  constructor(private translateService: TranslateService, private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.phrases$ = this.translateService.get('Enum').pipe(
      map((phrases) => ({
        actions: phrases.RequestHistoryAction,
        status: phrases.RequestHistoryStatus,
        creatorTypes: phrases.RequestCreatedByType,
      }))
    );

    if (this.logs && this.logs.length) {
      this.setListOfLogs();
    }
  }

  ngOnChanges({ logs }: SimpleChanges): void {
    if (this.phrases$ && logs && logs.currentValue !== logs.previousValue) {
      this.setListOfLogs();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  setListOfLogs(): void {
    this.logs.sort((a, b) => {
      const aTime = a.createdAt;
      const bTime = b.createdAt;
      if (aTime < bTime) {
        return -1;
      } else if (aTime > bTime) {
        return 1;
      }
      return 0;
    });

    this.phrases$.pipe(takeUntil(this.destroy$)).subscribe(({ actions, status, creatorTypes }) => {
      this.translatedLogList = (this.logs || []).map((request) => ({
        ...request,
        danger: request.status === RequestHistoryStatus.Failed,
        label: request.toType
          ? this.translateService.instant('Shipments.RequestLog', {
              action: actions[request.action] || request.action,
              from: creatorTypes[request.creatorType] || request.creatorType,
              to: creatorTypes[request.toType] || request.toType,
            })
          : this.translateService.instant('Shipments.RequestLogWithoutTo', {
              action: actions[request.action] || request.action,
              from: creatorTypes[request.creatorType] || request.creatorType,
            }),
      }));
    });
  }
  isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
  handleClickedAction({ item, action }): void {
    this.selectedItem = item;
    this.selectedAction = action;
    this.selectedItemPayload = this.isJson(this.selectedItem.responseData) ?
      JSON.parse(
      action === 'request' ? this.selectedItem.requestBody || '{}' : this.selectedItem.responseData || '{}'
    ) :
    action === 'request' ?
    JSON.parse(this.selectedItem.requestBody) : this.selectedItem.responseData;
    this.downloadString = this.domSanitizer.bypassSecurityTrustUrl(
      `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON?.stringify({
          requestUrl: item.requestUrl,
          createdBy: item.creatorType,
          [action === 'request' ? 'requestBody' : 'responseData']: this.selectedItemPayload,
        })
      )}`
    );

    this.requestModal.showModal();
  }
}
